'use strict';

exports.__esModule = true;
exports.default = createContainerQueryMixin;

var _raf = require('./raf');

var _containerQuery = require('./containerQuery');

var _DataStructure = require('./DataStructure');

/**
 * Create a mixin that can be
 *
 * @param {Object} query - Container query definitions
 * @param {Object} [opts] - Options
 * @param {boolean} [opts.setAttribute] - When true, mixin will set or unset
 *                                        attributes on container element
 *                                        according to current active container
 *                                        query
 *
 * @return {Object} A mixin object that can be applied to a component
 */
function createContainerQueryMixin(query) {
  var _ref = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var _ref$setAttribute = _ref.setAttribute;
  var setAttribute = _ref$setAttribute === undefined ? false : _ref$setAttribute;

  var getClasses = (0, _containerQuery.parseQuery)(query);

  return {
    defineContainer: function defineContainer(component) {
      this._containerElement = component;
    },
    componentDidMount: function componentDidMount() {
      var _this = this;

      this._containerQuerySelectorMap = null;
      this._size = { width: null, height: null };
      this._rafId = null;

      var checkDimension = function checkDimension() {
        var _containerElement = _this._containerElement;
        var width = _containerElement.clientWidth;
        var height = _containerElement.clientHeight;

        var changed = false;

        if (_this._size.width !== width) {
          changed = true;
        }

        if (_this._size.height !== height) {
          changed = true;
        }

        _this._size.width = width;
        _this._size.height = height;

        if (changed) {
          _this._updateAttributes();
        }

        _this._rafId = (0, _raf.requestAnimationFrame)(checkDimension);
      };

      checkDimension();
    },
    componentWillUnmount: function componentWillUnmount() {
      (0, _raf.cancelAnimationFrame)(this._rafId);
      this._rafId = null;
      this._containerElement = null;

      if (this.containerQueryWillUpdate) {
        this.containerQueryWillUpdate((0, _DataStructure.shallowCopyObj)(this._containerQuerySelectorMap));
      }

      this._containerQuerySelectorMap = null;

      if (this.containerQueryDidUpdate) {
        this.containerQueryDidUpdate((0, _DataStructure.shallowCopyObj)(this._containerQuerySelectorMap));
      }
    },
    _updateAttributes: function _updateAttributes() {
      var selectorMap = getClasses(this._size);

      if ((0, _containerQuery.isSelectorMapEqual)(this._containerQuerySelectorMap, selectorMap)) {
        return;
      }

      if (this.containerQueryWillUpdate) {
        this.containerQueryWillUpdate((0, _DataStructure.shallowCopyObj)(this._containerQuerySelectorMap));
      }

      this._containerQuerySelectorMap = selectorMap;

      if (setAttribute) {
        for (var _iterator = (0, _DataStructure.toPairs)(this._containerQuerySelectorMap), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
          var _ref2;

          if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref2 = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref2 = _i.value;
          }

          var _ref3 = _ref2;
          var selectorName = _ref3[0];
          var isOn = _ref3[1];

          if (isOn) {
            this._containerElement.setAttribute(selectorName, '');
          } else {
            this._containerElement.removeAttribute(selectorName);
          }
        }
      }

      if (this.containerQueryDidUpdate) {
        this.containerQueryDidUpdate((0, _DataStructure.shallowCopyObj)(this._containerQuerySelectorMap));
      }
    }
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-container-query/lib/createContainerQueryMixin.js
 ** module id = 62
 ** module chunks = 0
 **/